import type { HomeRecentAgentSessionAssociationsQuery$variables } from './__generated__/HomeRecentAgentSessionAssociationsQuery.graphql.ts';
import type { HomeRecentAgentSessionsQuery$variables } from './__generated__/HomeRecentAgentSessionsQuery.graphql.ts';

export const RECENT_AGENT_SESSIONS_OVERSCAN_COUNT = 25;

const escapeAqlValue = (value: string): string => value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");

const INVOCATION_TYPE_FILTER =
	"invocationType = 'CONFLUENCE_COMMENT_MENTION'" +
	" OR invocationType = 'CONFLUENCE_CHAT_EDIT'" +
	" OR invocationType = 'CONFLUENCE_INLINE_EDIT'" +
	" OR invocationType = 'CONFLUENCE_CWR_EDIT'" +
	" OR invocationType = 'CONFLUENCE_CWR_CREATE'" +
	" OR invocationType = 'CONFLUENCE_CWR_EXISTING'" +
	" OR invocationType = 'CONFLUENCE_REMIX'" +
	" OR invocationType = 'CONFLUENCE_REMIX_EDIT'" +
	" OR invocationType = 'CONFLUENCE_CHAT'";

export const getRecentAgentSessionsQueryVariables = ({
	userId,
	rovoActivationId,
	first = RECENT_AGENT_SESSIONS_OVERSCAN_COUNT,
}: {
	userId: string;
	rovoActivationId: string;
	first?: number;
}): HomeRecentAgentSessionsQuery$variables => {
	const escapedUserId = escapeAqlValue(userId);
	return {
		aqlQuery:
			`authorAccountId = '${escapedUserId}'` +
			" AND (state = 'INPUT_REQUIRED' OR state = 'AUTH_REQUIRED')" +
			` AND (${INVOCATION_TYPE_FILTER})`,
		shardingContext: `ari:cloud:rovo::workspace/${rovoActivationId}`,
		first,
	};
};

/**
 * Associations are keyed by (session, entity), so one session can hold several. This bounds the
 * scoped association query generously enough that no requested session is silently truncated away.
 */
const MAX_ASSOCIATIONS_PER_SESSION = 5;

export const getRecentAgentSessionAssociationsQueryVariables = ({
	rovoActivationId,
	sessionIds,
}: {
	rovoActivationId: string;
	sessionIds: readonly string[];
}): HomeRecentAgentSessionAssociationsQuery$variables => {
	const sessionIdFilter = sessionIds
		.map((sessionId) => `agentSessionId = '${escapeAqlValue(sessionId)}'`)
		.join(' OR ');
	return {
		aqlQuery: `(${sessionIdFilter}) AND deleted = 'false'`,
		first: sessionIds.length * MAX_ASSOCIATIONS_PER_SESSION,
		shardingContext: `ari:cloud:rovo::workspace/${rovoActivationId}`,
	};
};
